import { Box, Grid, LinearProgress, ListItem, ListItemText, Typography } from "@material-ui/core";
import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import Number from "../../../custom/Number";
import { contractProgress, isPremiumContract } from "../../../util";
import Moment from "react-moment";
import ContractPhaseDateLabel from "./ContractPhaseDateLabel";

const DEFAULT_AMOUNT = 1;

const ContractItem = ({ currentUser, contract }) => {
  const hasValidAmount = contract.amount && contract.amount !== DEFAULT_AMOUNT;
  const contractProgressValue = contractProgress(contract);

  return (
    <ListItem
      button
      component={Link}
      to={{ pathname: `/userContract/${contract.id}` }}
      divider
    >
      <ListItemText
        disableTypography
        primary={
          <>
            <Grid container>
              <Grid
                item
                xs={6}
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                  >
                    <Typography variant="body1">
                      {`C${contract.id} `}
                      <Typography
                        variant="caption"
                        color="textSecondary"
                        noWrap
                      >
                        {contract.type.durationInMonth}M <FormattedMessage id={"app.enuns." + contract.type.type} />
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                  >
                    <Typography
                      variant="body1"
                      color="primary"
                    >
                      <Number
                        value={hasValidAmount ? contract.amount : contract.previsionAmount}
                        currency="LCT"
                        hideValue={currentUser.hideValues}
                      />
                    </Typography>
                  </Grid>
                  {isPremiumContract(contract) && (
                    <Grid
                      item
                      xs={12}
                    >
                      <Typography
                        component={"span"}
                        variant="caption"
                        color="primary"
                      >
                        <FormattedMessage id={"app.premium"} />
                      </Typography>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                xs={6}
                align="end"
              >
                <Grid
                  container
                  spacing={1}
                  justifycontent="flex-end"
                >
                  <Grid
                    item
                    xs={12}
                  >
                    <ContractPhaseDateLabel contract={contract} />
                  </Grid>

                  {contract.phase === "EXECUTING" && (
                    <>
                      <Grid
                        item
                        xs={12}
                      >
                        <Typography
                          variant="body2"
                          color="textPrimary"
                        >
                          <FormattedMessage id="app.contract.phase.ends" />
                          <Moment
                            date={contract.dueDate}
                            format="DD/MM/YY"
                          />
                        </Typography>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        align="end"
                        justifycontent="flex-end"
                      >
                        <Box
                          justifyContent="flex-end"
                          style={{ display: "flex", alignItems: "center", gap: 4 }}
                        >
                          <Typography
                            variant="caption"
                            color="textSecondary"
                          >
                            <FormattedMessage id={"app.enuns." + contract.phase} />
                          </Typography>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                          >
                            {`${contractProgressValue}%`}
                          </Typography>
                          <LinearProgress
                            variant="determinate"
                            style={{ height: 10, width: "100%", maxWidth: 120 }}
                            value={contractProgressValue}
                          />
                        </Box>
                      </Grid>
                    </>
                  )}
                </Grid>
              </Grid>
            </Grid>
          </>
        }
      />
    </ListItem>
  );
};

export default ContractItem;
